export default "__VITE_ASSET___S_SrBv5__"